
/**
 *     Data-driven UI for JSON API models and API calls
 *
 *     @author Irina Patrikeeva <irina.i.ipatrikeeva@nasa.gov>
 *
 *     Created on 06/02/2017
 *     Modified on 08/16/2018
 *
 */

/**
 * Parse JSON model that represents data API calls
 * @param jsonModel {object} - JSON API model
 * @param pageName {string} - name of the page
 * @param data {[string]} - array of data call names
 * @param recordModel {BackboneModel} - record Backbone model
 * @returns {[string]} - array of URL calls
 */
function constructAPIs( jsonModel, pageName, data, recordModel ) {
    var urls = [],
        collection = getBackboneCollection( jsonModel.properties ),
        properties,
        sectionProperties,
        dependentData,
        dependentUrls,
        i,
        j,
        k;

    _.each( collection.models, function ( model ) {
        if ( model && model.get( "page" ) === pageName ) {
            properties = model.get( "properties" ); // Model data to construct API calls
            if ( properties ) {
                for ( j = 0; j < properties.length; j++ ) {
                    sectionProperties = properties[ j ];
                    // Construct url for each data section
                    for ( k = 0; k < data.length; k++ ) {
                        if ( data[ k ] === sectionProperties.name )  {
                            if ( !sectionProperties.dependsOn ) {
                                urls = constructUrl( urls, sectionProperties.parameters, sectionProperties.url, recordModel );
                            } else {
                                for ( i = 0; i < sectionProperties.dependsOn.length; i++ ) {
                                    // check if dependent data exists in the global page state
                                    if ( hasKeys( GlobalPageState.data )) {
                                        dependentData = GlobalPageState.data[ sectionProperties.dependsOn[ i ] ];
                                        dependentUrls = constructDependentUrls( sectionProperties.dependsOn[ i ], dependentData, data, pageName, recordModel );
                                        if ( dependentUrls ) {
                                            urls = dependentUrls;
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    });

    return urls;
}

/**
 * Construct a URL from parameters in the JSON API model
 * @param urls {[string]} - array of URL strings
 * @param parametersArray {[string]} - array of URL parameter names
 * @param urlArray {[string]} - array of URL values
 * @param recordModel {object} - Backbone collection of record fields
 * @returns {[string]} - array of URL strings
 */
function constructUrl( urls, parametersArray, urlArray, recordModel ) {
    var url = "",
        parameter,
        urlString,
        value,
        i;

    for ( i = 0; i < parametersArray.length; i++ ) {
        parameter = parametersArray[ i ];
        urlString = urlArray[ i ];
        if ( parameter && urlString ) {

            if ( parameter === "alias" ) {
                value = App.globalState.alias;

                if ( value ) {
                    url += urlString + value;
                }
            }
            else if ( parameter === "type" ) {
                value = GlobalPageState.type;
                if ( value ) {
                    url += urlString + value;
                }
            }
            else if ( parameter === "linksPageNumber" && GlobalPageState && GlobalPageState.currentPage === "record") {
                // Set the page parameter for links to GlobalPageState linksPageNumber attribute
                value = GlobalPageState[ parameter ];
                if ( ! value ) {
                    value = 1;
                }
                url += urlString + value;
            }
            else {
                // Get the value from the ES record data
                value = recordModel.get( parameter );
                if ( value ) {
                    url += urlString + recordModel.get( parameter );
                }
            }

        }
    }
    if ( url ) {
        urls.push( url );
    }
    return urls;
}

/**
 * Get dependent URLs
 * @param sectionProperties {Object} - section properties object
 * @param names {[string]} - data names for the section
 * @param name {string} - section name on which URL construction depends
 * @param recordModel {BackboneModel} - Backbone record model of data on which URL depends
 * @returns {[string]} - array of URLs
 */
function getDependentSectionUrls( sectionProperties, names, name, recordModel ) {

    var url,
        dependsOn,
        k,
        n,
        urls = [];

    if ( sectionProperties ) {
        dependsOn = sectionProperties.dependsOn;
        if ( dependsOn ) {
            for ( n = 0; n < dependsOn.length; n++ )  {
                // Construct url for each data section with dependencies
                for ( k = 0; k < names.length; k++ ) {
                    if ( names[k] === sectionProperties.name && sectionProperties.dependsOn ) {
                        if ( dependsOn[n] === name ) {
                            url = constructUrl( urls, sectionProperties.parameters, sectionProperties.url, recordModel );
                        }
                    }
                }
            }
        }
    }
    return url;
}

/**
 * Construct URLs for data that depends on other URL data
 * @param name {string} - section name on which URL construction depends
 * @param data {Object} - data on which URL construction depends
 * @param names {[string]} - data names for the section
 * @param pageName {string} - page name
 * @param pageModel {object} - Backbone model containing information URL parameters and page information
 * @returns {[string]} - URL array
 */
function constructDependentUrls( name, data, names, pageName, pageModel ) {
    var collection,
        properties,
        recordModel,
        urls = [],
        json,
        sectionUrls,
        key,
        field,
        response,
        attributes,
        j;

    if ( GlobalPageState && GlobalPageState.type ) {

        json = getJSONModel( "api", GlobalPageState.type, null );

        if ( json ) {
            collection = getBackboneCollection( json.properties );
            if ( collection ) {
                _.each( collection.models, function ( model ) {
                    if ( model.get( "page" ) === pageName ) {
                        properties = model.get( "properties" );
                        recordModel = new BackboneModel();
                        if ( data && data.hits && data.hits.hits ) {
                            if ( data.hits.hits.length === 1 ) {
                                response = data.hits.hits[0];
                                // for ( field in response._source ) {
                                //     if (response._source.hasOwnProperty( field ) ) {
                                //         recordModel.set( field, response._source[ field ] );
                                //     }
                                // }

                                // Create a Backbone model that contains top-level and source fields from the response object
                                if ( response ) {
                                    // Save top-level fields into a Backbone model
                                    for ( field in response ) {
                                        if (response.hasOwnProperty( field )) {
                                            recordModel.set( field, response[ field ]);
                                        }
                                    }

                                    // Save fields inside the _source object into a Backbone model
                                    for ( field in response._source ) {
                                        if ( response._source.hasOwnProperty( field ) ) {
                                            recordModel.set( field, response._source[ field ] );
                                        }
                                    }
                                }

                                if ( model ) {
                                    // Save information needed for URL construction into recordModel
                                    attributes = pageModel.attributes;
                                    for ( key in attributes ) {
                                        if ( attributes.hasOwnProperty( key ) ) {
                                            recordModel.set( key, attributes[ key ]);
                                        }
                                    }
                                    if ( properties ) {
                                        for ( j = 0; j < properties.length; j++ ) {
                                            // Construct a URL that has a dependency on another section
                                            sectionUrls = getDependentSectionUrls( properties[j], names, name, recordModel );
                                            if ( sectionUrls && sectionUrls.length > 0 ) {
                                                urls.push( sectionUrls );
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                });
            }
        }
    }
    return urls;
}

/**
 * Compare data object keys with items in the dataNames array
 * @param data {object} - data object
 * @param dataNames {[string]} - array of data names from API model
 * @returns {boolean} - returns true if number of keys in the data object matches number of items in the dataNames object
 */
function doAPINamesMatch( data, dataNames ) {
    var result = false,
        isFound = [],
        key,
        j;

    // Compare number of data names to the number of items in the dataNames array
    if ( hasKeys( data ) && dataNames && Object.keys( data ).length !== dataNames.length ) {
        return result;
    }

    // Compare data object keys with items in the dataNames array
    for ( key in data ) {
        if ( data.hasOwnProperty( key ) ) {
            for ( j = 0; j < dataNames.length; j++ ) {
                if ( key === dataNames[ j ]) {
                    isFound.push( true );
                }
            }
        }
    }
    // Return true if the number of keys in the data object matches the number of items in the dataName array
    if ( isFound.length === dataNames.length ) {
        result = true;
    }
    return result;
}

/**
 * Get API region model name based on the data name
 * @param type {string} - API Model data type name
 * @param dataName {string} - API Model region name, i.e. "metadata", "parents", etc.
 * @return {*}
 */
function getAPIModelDataType( type, dataName ) {

    var result,
        properties,
        props,
        propertiesArray,
        property,
        recordAPIModel = getJSONAPI( type ),
        i;

    if ( recordAPIModel ) {
        properties = recordAPIModel.properties;
        if ( properties && properties.length === 1 ) {
            props = properties[0];
            if ( props ) {
                propertiesArray = props.properties;
                if ( propertiesArray ) {
                    for ( i = 0; i < propertiesArray.length; i++ ) {
                        property = propertiesArray[ i ];
                        if ( property && property.name === dataName ) {
                            result = property.model;
                        }
                    }
                }
            }
        }
    }
    return result;
}